/**
 * 臻有钱订单（提现）状态
 */
export enum OrderStatusV2Enum {
  ALL = 0,
  INIT = 'INIT', // '初始状态',
  PENDING = 'PENDING', // '排队中',
  USERPASSED = 'USERPASSED', // '初筛通过',

  REJECTED = 'REJECTED', // '已拒绝',
  CANCELLED = 'CANCELLED', // '已取消',

  SUBMITTING = 'SUBMITTING', // '提交中',

  SUBMITTED = 'SUBMITTED', // '已提交', 提现申请中
  BINDING = 'BINDING', // '绑卡中',

  BOUND = 'BOUND', // '绑卡成功', 提现申请中
  BIND_FAILED = 'BIND_FAILED', // '绑卡失败',

  LENDING = 'LENDING', // '放款中', 提现申请中
  LEND_FAILED = 'LEND_FAILED', // '放款失败' 提现失败,
  LENT = 'LENT', // '已放款' 待还款,

  PAYOFF = 'PAYOFF', // '已还清',
  SIGNING = 'SIGNING', // 签约中
  SIGNED = 'SIGNED', // 签约成功
  SIGN_FAILED = 'SIGN_FAILED', // 签约失败
}

export const OrderStatusV2EnumToLabel: { [key: string]: string } = {
  INIT: '初始状态',
  PENDING: '排队中',
  USERPASSED: '初筛通过',
  REJECTED: '已拒绝',
  CANCELLED: '已取消',
  SUBMITTING: '提交中',
  SUBMITTED: '提现申请中',
  BINDING: '绑卡中',
  BOUND: '绑卡成功',
  BIND_FAILED: '绑卡失败',
  LENDING: '提现申请中',
  LEND_FAILED: '提现失败',
  LENT: '已放款',
  PAYOFF: '已还清',
  SIGNING: '提现申请中',
  SIGNED: '提现申请中',
  SIGN_FAILED: '提现申请中',
};

/** 提现结果页类型 */
export enum OrderResultEnum {
  /** 提现申请中 */
  LENDING = 'LENDING',
  /** 提现失败 */
  LEND_FAILED = 'LEND_FAILED',
  /** 提现成功 待还款 */
  LENT = 'LENT',
}

/** 订单类型 */
export enum OrderTypeEnum {
  /** 普通订单 */
  NORMAL = 'NORMAL',
  /** 零用钱订单 */
  POCKET_MONEY = 'POCKET_MONEY',
}
